import React from "react";
import { WarningOutlined } from "@ant-design/icons";
import { styled } from "styled-components";
import { Divider } from "antd";

const NoData = () => {
  return (
    <Container>
      <Divider>
        <WarningOutlined style={{ fontSize: "100px" }} />
        <h2>ไม่มีข้อมูล</h2>
      </Divider>
    </Container>
  );
};

const Container = styled.div`
  height: 70dvh;
  display: flex;
  align-items: center;
`;

export default NoData;
